import { useState } from 'react';
import styles from './NavBar.module.scss';
import {Link} from 'react-router-dom';
import CustomButton from '../../CustomComponents/CustomButton';
import { theme } from '../../theme';
import {
    isUserLogged, useIsCompany,
} from '../../utils/utilFunctions';
import { logout } from '../../utils/utilFunctions';
import { useTranslation } from 'react-i18next';
import {Drawer, Tooltip} from "antd";
import OptionalsHeadersLinks from "./OptionalsHeadersLinks";

const NavBarMobile = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const isCompany = useIsCompany();

    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };


    return (
        <div className={styles.navBar}>
            <Drawer
                className={styles.opened}
                placement={"top"}
                closable={true}
                onClose={onClose}
                visible={visible}
                size={'large'}
                key={"top"}
            >
                <div className={styles.opened}>
                    <div className={styles.drawerHeaderContainer}>
                        <div className={styles.flexChild}>
                            <OptionalsHeadersLinks/>
                        </div>
                    </div>
                    <div className={styles.line} />
                    <div className={styles.openLink}>
                        {!isUserLogged() ? (
                            <CustomButton
                                backgroundcolor={theme.primaryColorACS}
                                textcolor={theme.white}
                                marginleft={"auto"}
                                marginright={"auto"}
                                marginbottom={"5%"}
                            >
                            <Link to='/autentificare'>
                                {t('header.login')}
                            </Link>
                            </CustomButton>) : null}
                    </div>
                    <div className={styles.openLink}>
                        {isUserLogged() &&
                        <Tooltip title={t('header.signout')}>
                            <CustomButton
                                backgroundcolor={theme.secondColorACS}
                                textcolor={theme.white}
                                onClick={() => logout(!isCompany)}
                                marginleft={"auto"}
                                marginright={"auto"}
                            >
                                <Link to="/">{t('header.logout')}</Link>
                            </CustomButton>
                        </Tooltip>}
                        
                        <CustomButton
                            backgroundcolor={theme.primaryColorACS}
                            textcolor={theme.white}
                            marginleft={"auto"}
                            marginright={"auto"}
                        >
                            <a href='https://support.upb.ro/open.php' target={'_blank'} rel='noreferrer'>
                                Suport
                            </a>
                        </CustomButton>
                    </div>
                </div>
            </Drawer>
            <span style={{ fontSize: "17px", cursor: "pointer" }} onClick={showDrawer}>
                <h1>&#9776;</h1>
            </span>
        </div>
        );
}

export default NavBarMobile;